import { MerchantPromotionV3Facade } from '@goparrot/promotions-sdk';
import { getConfig, getInterceptors } from '../../request';

export const merchantPromotionV3Facade = new MerchantPromotionV3Facade(getConfig('promotions'), getInterceptors());
